import { EMachineConfigUIViewType } from '_clean-code/types/config';

export const NOTIFICATION_DISMISSION_STATUSES = {
  READ: 'read',
  DISMISS: 'dismiss'
};
export const defaultLang = 'es';
export const SELECTED_COMPANY_ID = 'Pulsar.SelectedCompanyId'; // TODO: this value is also in public/index.html as plain text please update it there
export const pageTitles = {
  '/dashboard': 'dashboard',
  '/realtime': 'realtime',
  '/production': 'production',
  '/stops': 'stops',
  '/analytics': 'analytics(availability)',
  '/analytics/stop-annotation': 'analytics(stop annotation)',
  '/analytics/stops': 'analytics(stops)',
  'analytics/historical': 'analytics(historical)',
  'analytics/shift': 'analytics(shift)',
  'analytics/pareto': 'analytics(pareto for stops)',
  'analytics/pareto/filters': 'analytics(pareto for machines)',
  '/data/reports': 'data reports',
  '/stopsettings/downtime-causes': 'downtime causes',
  '/stopsettings/tree-losses': 'tree losses',
  '/stopsettings/assign-machine': 'stop settings(assign machines)',
  '/production-settings/sku': 'skus',
  '/production-settings/work-order': 'work orders',
  '/production-settings/nominal-speed': 'nominal speeds',
  '/production-settings/machine-mapping': 'machine mappings',
  '/production-settings/operator': 'operators',
  '/alerts': 'alert settings',
  '/alerts/recipients': 'alert recipients',
  '/shift-not-considered': 'idle shifts',
  '/shift-settings': 'shift settings',
  '/tv-settings': 'tv settings',
  '/machine-settings': 'machine groups',
  '/users-settings': 'user settings',
  '/create-ticket': 'support ticket'
};
/**
 * The default locale is 'es'. Since it is not stored in the database,
 * english-speaking users displaying pulsar in remote devices may experience issues.
 * This is a list of company ids who will display pulsar in english by default
 */
export const US_LOCALE_COMPANY_IDS = [
  '10122', // BTD - Lakeville
  '10181', // NDS
  '10212', // Fathom Machining
  '10201', // Vertiv - USA - Lincoln
  '10205', //	Vertiv - USA - Ironton
  '10228', // Vertiv - USA - Anderson
  '10242', //	Vertiv
  '10202', //	Bonide
  '10239', // WasteZero
  '10237', // Manthei Petosky
  '10209', //	Model Dairy
  '10073' //	A&R
];

export const ALEN_COMPANY_IDS = [99, 124, 147, 148, 150, 158, 10047];
export const RECUPAC_COMPANY_ID = 10158;
export const FORTACERO_COMPANY_ID = 19;
export const BTD_COMPANY_ID = 10122;
export const BECKTEL_COMPANY_ID = 10244;
export const CREMERIA_AMERICANA_COMPANY_ID = 10235;
export const NDS_COMPANY_ID = 10181;
export const ETIMEX_COMPANY_ID = 10203;
export const MATERIA_COMPANY_ID = 10280;
export const OMNILIFE_COLOMBIA_COMPANY_ID = 10175;
export const EMPACADORA_DEL_GOLFO_VERACRUZ_COMPANY_ID = 10419;

// Test accounts
// 6	Demo
// 168	Demo 3
// 10024	Demo QA
// 10146	Demo OEE - CS
// 10155	Demo - OEE Pro (ES)
// 10156	Demo Sales Corp
// 10157	Demo - OEE Pro (EN)
export const DEMO_COMPANY_IDS = [
  6, 168, 10024, 10146, 10155, 10156, 10157
] as const;

// Cosmocel San Nicolas, Cosmocel Interpuerto, Cosmocel Corp
export const COSMOCEL_COMPANY_IDS = [10260, 10264, 10265] as const;

export const ACEROMEX_COMPANY_IDS = [50, 10023, 10192, 10426] as const;

/**
 * Decimal values are supported by default. These registries hold the companies
 * that opt OUT of decimal input (integer-only) per feature. An empty list means
 * every company gets decimal support for that feature.
 */
export const INTEGER_ONLY_PRODUCTION_COMPANY_IDS: number[] = [];
export const INTEGER_ONLY_DEFECTS_COMPANY_IDS: number[] = [];
/**
 * Same as above, but for aggregate metrics displayed in the realtime and TV
 * mode views and in the Metrics page table (and its CSV export) — e.g. Total
 * Products, Correct, Defects/Scrap — independent of whether the company's
 * production/defects inputs themselves allow decimals.
 */
export const INTEGER_ONLY_METRICS_DISPLAY_COMPANY_IDS: number[] = [
  OMNILIFE_COLOMBIA_COMPANY_ID,
  EMPACADORA_DEL_GOLFO_VERACRUZ_COMPANY_ID,
  ...ACEROMEX_COMPANY_IDS
];
// These companies want to enforce all fields to be selected when classifying stops
export const NO_EMPTY_FIELDS_STOP_CLASSIFICATION_IDS = [
  ...ALEN_COMPANY_IDS,
  RECUPAC_COMPANY_ID,
  FORTACERO_COMPANY_ID,
  CREMERIA_AMERICANA_COMPANY_ID
];

/**
 * limit of rows to be downloaded in reports
 */
export const REPORTS_PAGE_SIZE = 1000;
export const STOPS_REPORT_PAGE_SIZE = 20_000;

/**
 * how often we poll for stops data in the stops page
 */
export const STOPS_REFRESH_INTERVAL = 1000 * 60;

export const REALTIME_SETTINGS = {
  REFETCH_INTERVAL: 30_000,
  /**
   * Whether the user can select multiple machines at once in the realtime settings
   */
  ALLOW_MULTI_MACHINE_CONFIG: true,
  /**
   * The maximum number of metrics that can be selected for a given view type
   */
  MAX_METRICS: {
    [EMachineConfigUIViewType.DesktopNonKpi]: 7,
    [EMachineConfigUIViewType.TvKpi]: 4,
    [EMachineConfigUIViewType.TvSingleMachine]: 4,
    [EMachineConfigUIViewType.TvTowerView2x2]: 4,
    [EMachineConfigUIViewType.TvTowerView3x3]: 2,
    [EMachineConfigUIViewType.TvTowerView6x3]: 0
  },
  MIN_METRICS: {
    [EMachineConfigUIViewType.DesktopNonKpi]: 1,
    [EMachineConfigUIViewType.TvKpi]: 1,
    [EMachineConfigUIViewType.TvSingleMachine]: 1,
    [EMachineConfigUIViewType.TvTowerView2x2]: 1,
    [EMachineConfigUIViewType.TvTowerView3x3]: 1,
    [EMachineConfigUIViewType.TvTowerView6x3]: 0
  }
};

/**
 * This should be temporal as it should be handled in the backend
 */
export const METRICS_BLACKLIST = ['scrap', 'currentAvailability'];

export const MAX_CUSTOM_FIELDS = 5;
